/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import merge from 'lodash/merge';
import { getReroutableURL } from '@atlassian/jira-fetch/src/utils/get-reroutable-url.tsx';
import { applyObservabilityHeaders } from '@atlassian/jira-fetch/src/index.tsx';
import { getDefaultOptions } from '@atlassian/jira-fetch/src/utils/fetch-default-options.tsx';

const relayDeferAcceptableFormats = [
	'application/graphql-response+json',
	'application/json',
	// there must not be spacing between `multipart/mixed` and `deferSpec=20220824` since the backend assumes no spacing
	'multipart/mixed;deferSpec=20220824',
].join(', ');

export function buildGraphqlFetch(url: string, options?: RequestInit): () => Promise<Response> {
	const postOptions = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Accept: relayDeferAcceptableFormats,
		},
	};

	const composedOptions = merge(getDefaultOptions(url), options, postOptions);
	const fetchUrl = getReroutableURL(url);
	const fetchHeaders = applyObservabilityHeaders(url, composedOptions);

	return () => fetch(fetchUrl, fetchHeaders);
}
